<template>
  <v-app-bar class="app-bar-header">
    <v-toolbar-title class="app-title">  
      <div v-if="DigitalCodeDescription" class="titleText1">{{ DigitalCodeDescription }}</div>
      <template v-else>
        <div class="titleText1">{{ titleText1 }}</div>
        <div class="titleText2">{{ titleText2 }}</div>
      </template>
    </v-toolbar-title>
    <div class="end-div" />
  </v-app-bar>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
    }
  },
  props: {
    stopDescription: {
      type: Object,
      required: true,
    },
    multiStop: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    capitalizeEveryWord(sentence) {
      return sentence == null
        ? ""
        : sentence.split(' ')  
                  .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) 
                  .join(' ');
    },
    capitalizeFirstCharacter(sentence) {
      return sentence == null
        ? ""
        : sentence.split(' ')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');
    },
  },
  computed: {
    ...mapState(["selectedLanguage", "digitalCodeDescription", "digitalCodeDescriptionCy"]),
    isWelsh() {
      return this.selectedLanguage === 'cy';
    },
    // Only the common name has a Welsh version (NaPTAN alternative descriptor),
    // so in Welsh it's shown on its own rather than between an English indicator
    // and street. Used as supplied: NaPTAN's Welsh casing is already correct and
    // capitalizeEveryWord would turn "Ffordd y Brenin" into "Ffordd Y Brenin".
    welshCommonName() {
      return this.isWelsh ? (this.stopDescription?.commonNameCy ?? '').trim() : '';
    },
    titleText1() {
      if (this.welshCommonName) return this.welshCommonName;
      return  `${this.capitalizeFirstCharacter(this.stopDescription?.indicator ?? '')} ${this.capitalizeEveryWord(this.stopDescription?.commonName ?? '')}`.trim()
    },
    titleText2() {
      if (this.welshCommonName) return '';
      return  this.capitalizeEveryWord(this.stopDescription?.street ?? '')
    },
    // Description in the selected language if set; otherwise fall back to the
    // stop titles. A multi-stop code has no stop titles, so there the other
    // language's description is used rather than showing an empty header.
    DigitalCodeDescription() {
      const description = this.isWelsh ? this.digitalCodeDescriptionCy : this.digitalCodeDescription;
      if (description?.trim()) return this.capitalizeEveryWord(description);
      if (this.multiStop) return this.capitalizeEveryWord(this.digitalCodeDescription || this.digitalCodeDescriptionCy || '');
      return '';
    },
  },
};
</script>

<style scoped>
.titleText1, .titleText2 {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  justify-self: start;

}
.app-title {
  color: white;
  font-size: 20px;
  margin-left:26px !important; 
  border-radius: 20px;

}
.app-image {
  height: 40px;
  width: 40px;
  margin-left: 20px;
  
}

.end-div {
  height: 40px;
  width: 40px;
  margin-right: 10px;
}

.time-display {
  margin-right: 5px;
  color: white !important;
}

.operator-row {
  border-end-end-radius: 10px;
  border-end-start-radius: 10px;
  background-color: rgb(var(--v-theme-surface-bright)) !important;
}
/* Green in every build. It used to be a development-only "debug" colour, with production
   white, so the tested look (green) differed from live. */
.app-bar-header {
  background-color: #2e9d6a !important;
  border-bottom-left-radius: 10px !important;
  border-bottom-right-radius: 10px !important;
}
</style>